import React from 'react';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Carlos M.',
  role: 'Consultor Independiente',
  content: 'Antes me daba pánico decir el precio porque siempre me dejaban en visto. Apliqué el Tomo 3 (Preguntas) y ahora los clientes me justifican a mí por qué necesitan mi servicio. Cerré 3 ventas esta semana.'
}, {
  name: 'Laura G.',
  role: 'Dueña de Tienda Online',
  content: 'Pensé que mi producto era caro. Resulta que estaba respondiendo como un robot. El sistema me enseñó a guiar la conversación. Mi tasa de conversión por WhatsApp pasó del 5% al 22% en menos de un mes.'
}, {
  name: 'David R.',
  role: 'Agencia de Marketing',
  content: 'El bono de "Seguimiento Sin Persecución" vale 10 veces lo que cuesta todo el producto. Recuperé a 4 prospectos que daba por perdidos solo cambiando dos palabras en mi mensaje de seguimiento.'
}, {
  name: 'Ana P.',
  role: 'Coach de Negocios',
  content: 'Lo leí el martes, lo apliqué el miércoles y cerré un paquete high-ticket el jueves. No es teoría aburrida, es exactamente qué decir y cuándo decirlo. Brutal.'
}];
export function Testimonials() {
  return <section className="bg-brand-white px-4 py-20 sm:px-6 lg:px-8" data-id="element-230">
      <div className="mx-auto max-w-7xl" data-id="element-231">
        <div className="text-center mb-16" data-id="element-232">
          <h2 className="text-3xl font-bold text-brand-black sm:text-4xl mb-4" data-id="element-233">
            Resultados Reales de Personas Reales
          </h2>
          <p className="text-xl text-gray-600" data-id="element-234">
            Vendedores que dejaron de perseguir y empezaron a cerrar.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2" data-id="element-235">
          {TESTIMONIALS.map((testimonial, idx) => <div key={idx} className="rounded-2xl bg-gray-50 p-8 border border-gray-100 shadow-sm" data-id="element-236">
              <div className="flex gap-1 mb-4" data-id="element-237">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-brand-green text-brand-green" data-id="element-238" />)}
              </div>
              <p className="mb-6 text-lg text-gray-700 italic" data-id="element-239">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4" data-id="element-240">
                <div className="h-12 w-12 rounded-full bg-brand-green/20 flex items-center justify-center font-bold text-brand-green text-xl" data-id="element-241">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-242">
                  <p className="font-bold text-brand-black" data-id="element-243">
                    {testimonial.name}
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-244">{testimonial.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}